// Extracted from soul .babylon file
// 2 mesh(es), 2 material(s), generated 2025-12-25
// Transforms are baked into vertex positions

import type { RuneMesh, RuneMaterials } from "./types.js";

export const SOUL_MATERIALS: RuneMaterials = [
  {
    name: "02___Default",
    albedoColor: [0.21570000, 0.21570000, 0.21570000],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
  {
    name: "01___Default",
    albedoColor: [0.20780000, 0.21570000, 0.47839999],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
];

const SOUL_MESH_0: RuneMesh = {
  name: "Soul_Rune_primitive0",
  positions: new Float32Array([
    -0.79460001, 0.43309999, -0.00000003,
    -0.83679998, 0.42829999, -0.00000003,
    -0.81849998, 0.42829999, -0.17400002,
    -0.77719998, 0.43309999, -0.16520002,
    -0.72589999, 0.43309996, -0.32320002,
    -0.64289999, 0.43309996, -0.46710002,
    -0.53170002, 0.43309996, -0.59050006,
    -0.39730000, 0.43309993, -0.68820006,
    -0.24550000, 0.43309993, -0.75570005,
    -0.08310000, 0.43309993, -0.79030007,
    0.08310000, 0.43309993, -0.79030007,
    0.24550000, 0.43309993, -0.75570005,
    0.39730000, 0.43309993, -0.68820006,
    0.53170002, 0.43309996, -0.59050006,
    0.64289999, 0.43309996, -0.46710002,
    0.72589999, 0.43309996, -0.32320002,
    0.77719998, 0.43309999, -0.16520002,
    0.67720002, 0.43309999, -0.11500003,
    0.67720002, 0.43309999, -0.11500003,
    0.54130000, 0.43309996, -0.39700004,
    0.54130000, 0.43309996, -0.39700004,
    0.31029999, 0.43309999, 0.01069997,
    0.31029999, 0.43309999, 0.01069997,
    0.31029999, 0.43309999, 0.01069997,
    0.02160000, 0.43309999, 0.16349997,
    0.02160000, 0.43309999, 0.16349997,
    -0.07010000, 0.43309999, 0.11259997,
    -0.07010000, 0.43309999, 0.11259997,
    -0.07010000, 0.43309999, 0.11259997,
    -0.30450001, 0.43309999, -0.02670003,
    -0.30450001, 0.43309999, -0.02670003,
    -0.48120001, 0.43309996, -0.45810002,
    -0.48120001, 0.43309996, -0.45810002,
    -0.63400000, 0.43309999, -0.14900003,
    -0.63400000, 0.43309999, -0.14900003,
    -0.57969999, 0.43310001, 0.26199996,
    -0.57969999, 0.43310001, 0.26199996,
    -0.29769999, 0.43310001, 0.49299997,
    -0.29769999, 0.43310001, 0.49299997,
    -0.10750000, 0.43310001, 0.29259998,
    -0.10750000, 0.43310001, 0.29259998,
    0.07250000, 0.43310001, 0.36729997,
    0.07250000, 0.43310001, 0.36729997,
    0.25929999, 0.43310001, 0.54059994,
    0.25929999, 0.43310001, 0.54059994,
    0.52770001, 0.43310001, 0.30619997,
    0.52770001, 0.43310001, 0.30619997,
    0.79460001, 0.43309999, -0.00000003,
    0.77719998, 0.43309999, 0.16519997,
    0.72589999, 0.43310001, 0.32319996,
    0.64289999, 0.43310001, 0.46709996,
    0.53170002, 0.43310001, 0.59049994,
    0.39730000, 0.43310004, 0.68809992,
    0.24550000, 0.43310004, 0.75569993,
    0.08310000, 0.43310004, 0.79029995,
    -0.08310000, 0.43310004, 0.79029995,
    -0.24550000, 0.43310004, 0.75569993,
    -0.39730000, 0.43310004, 0.68809992,
    -0.53170002, 0.43310001, 0.59049994,
    -0.64289999, 0.43310001, 0.46709996,
    -0.72589999, 0.43310001, 0.32319996,
    -0.77719998, 0.43309999, 0.16519997,
    -0.81849998, 0.42829999, 0.17399997,
    -0.87690002, 0.41429999, -0.00000003,
    -0.85769999, 0.41429999, -0.18230003,
    -0.76450002, 0.42829996, -0.34040004,
    -0.67699999, 0.42829996, -0.49190003,
    -0.55989999, 0.42829993, -0.62190008,
    -0.41839999, 0.42829993, -0.72470003,
    -0.25860000, 0.42829993, -0.79590005,
    -0.08750000, 0.42829993, -0.83220005,
    0.08750000, 0.42829993, -0.83220005,
    0.25860000, 0.42829993, -0.79590005,
    0.41839999, 0.42829993, -0.72470003,
    0.55989999, 0.42829993, -0.62190008,
    0.67699999, 0.42829996, -0.49190003,
    0.76450002, 0.42829996, -0.34040004,
    0.81849998, 0.42829999, -0.17400002,
    0.83679998, 0.42829999, -0.00000003,
    0.81849998, 0.42829999, 0.17399997,
    0.76450002, 0.42830002, 0.34039998,
    0.67699999, 0.42830002, 0.49189997,
    0.55989999, 0.42830005, 0.62189996,
    0.41839999, 0.42830005, 0.72469991,
    0.25860000, 0.42830005, 0.79579991,
    0.08750000, 0.42830005, 0.83219993,
    -0.08750000, 0.42830005, 0.83219993,
    -0.25860000, 0.42830005, 0.79579991,
    -0.41839999, 0.42830005, 0.72469991,
    -0.55989999, 0.42830005, 0.62189996,
    -0.67699999, 0.42830002, 0.49189997,
    -0.76450002, 0.42830002, 0.34039998,
    -0.85769999, 0.41429999, 0.18229997,
    -0.91280001, 0.39170000, -0.00000003,
    -0.89289999, 0.39170000, -0.18980002,
    -0.80110002, 0.41429996, -0.35670003,
    -0.70940000, 0.41429996, -0.51540005,
    -0.58679998, 0.41429994, -0.65170008,
    -0.43840000, 0.41429994, -0.75940007,
    -0.27100000, 0.41429994, -0.83400005,
    -0.09170000, 0.41429994, -0.87210006,
    0.09170000, 0.41429994, -0.87210006,
    0.27100000, 0.41429994, -0.83400005,
    0.43840000, 0.41429994, -0.75940007,
    0.58679998, 0.41429994, -0.65170008,
    0.70940000, 0.41429996, -0.51540005,
    0.80110002, 0.41429996, -0.35670003,
    0.85769999, 0.41429999, -0.18230003,
    0.87690002, 0.41429999, -0.00000003,
    0.85769999, 0.41429999, 0.18229997,
    0.80110002, 0.41430002, 0.35669997,
    0.70940000, 0.41430002, 0.51539993,
    0.58679998, 0.41430005, 0.65169996,
    0.43840000, 0.41430005, 0.75939995,
    0.27100000, 0.41430005, 0.83399993,
    0.09170000, 0.41430005, 0.87209994,
    -0.09170000, 0.41430005, 0.87209994,
    -0.27100000, 0.41430005, 0.83399993,
    -0.43840000, 0.41430005, 0.75939995,
    -0.58679998, 0.41430005, 0.65169996,
    -0.70940000, 0.41430002, 0.51539993,
    -0.80110002, 0.41430002, 0.35669997,
    -0.89289999, 0.39170000, 0.18979996,
    -0.94290000, 0.36170000, -0.00000003,
    -0.92229998, 0.36170000, -0.19600002,
    -0.83389997, 0.39169997, -0.37130004,
    -0.73850000, 0.39169997, -0.53659999,
    -0.61080003, 0.39169994, -0.67839998,
    -0.45640001, 0.39169994, -0.79060000,
    -0.28209999, 0.39169994, -0.86820000,
    -0.09540000, 0.39169994, -0.90789998,
    0.09540000, 0.39169994, -0.90789998,
    0.28209999, 0.39169994, -0.86820000,
    0.45640001, 0.39169994, -0.79060000,
    0.61080003, 0.39169994, -0.67839998,
    0.73850000, 0.39169997, -0.53659999,
    0.83389997, 0.39169997, -0.37130004,
    0.89289999, 0.39170000, -0.18980002,
    0.91280001, 0.39170000, -0.00000003,
    0.89289999, 0.39170000, 0.18979996,
    0.83389997, 0.39170003, 0.37129998,
    0.73850000, 0.39170003, 0.53659999,
    0.61080003, 0.39170006, 0.67839998,
    0.45640001, 0.39170006, 0.79049999,
    0.28209999, 0.39170006, 0.86820000,
    0.09540000, 0.39170006, 0.90780002,
    -0.09540000, 0.39170006, 0.90780002,
    -0.28209999, 0.39170006, 0.86820000,
    -0.45640001, 0.39170006, 0.79049999,
    -0.61080003, 0.39170006, 0.67839998,
    -0.73850000, 0.39170003, 0.53659999,
    -0.83389997, 0.39170003, 0.37129998,
    -0.92229998, 0.36170000, 0.19599997,
    -0.96550000, 0.32570001, -0.00000002,
    -0.94440001, 0.32569999, -0.20070003,
    -0.86140001, 0.36169997, -0.38350004,
    -0.76279998, 0.36169997, -0.55419999,
    -0.63090003, 0.36169994, -0.70069999,
    -0.47139999, 0.36169994, -0.81660002,
    -0.29139999, 0.36169994, -0.89670002,
    -0.09860000, 0.36169994, -0.93769997,
    0.09860000, 0.36169994, -0.93769997,
    0.29139999, 0.36169994, -0.89670002,
    0.47139999, 0.36169994, -0.81660002,
    0.63090003, 0.36169994, -0.70069999,
    0.76279998, 0.36169997, -0.55419999,
    0.86140001, 0.36169997, -0.38350004,
    0.92229998, 0.36170000, -0.19600002,
    0.94290000, 0.36170000, -0.00000003,
    0.92229998, 0.36170000, 0.19599997,
    0.86140001, 0.36170003, 0.38349998,
    0.76279998, 0.36170003, 0.55419999,
    0.63090003, 0.36170006, 0.70069999,
    0.47139999, 0.36170006, 0.81660002,
    0.29139999, 0.36170006, 0.89670002,
    0.09860000, 0.36170006, 0.93769997,
    -0.09860000, 0.36170006, 0.93769997,
    -0.29139999, 0.36170006, 0.89670002,
    -0.47139999, 0.36170006, 0.81660002,
    -0.63090003, 0.36170006, 0.70069999,
    -0.76279998, 0.36170003, 0.55419999,
    -0.86140001, 0.36170003, 0.38349998,
    -0.94440001, 0.32570004, 0.20069997,
    -0.97950000, 0.28560001, -0.00000002,
    -0.95810002, 0.28559998, -0.20370002,
    -0.88200003, 0.32569999, -0.39270002,
    -0.78109998, 0.32569999, -0.56750000,
    -0.64600003, 0.32569996, -0.71749997,
    -0.48269999, 0.32569996, -0.83609998,
    -0.29830000, 0.32569996, -0.91820002,
    -0.10090000, 0.32569996, -0.96020001,
    0.10090000, 0.32569996, -0.96020001,
    0.29830000, 0.32569996, -0.91820002,
    0.48269999, 0.32569996, -0.83609998,
    0.64600003, 0.32569996, -0.71749997,
    0.78109998, 0.32569999, -0.56750000,
    0.88200003, 0.32569999, -0.39270002,
    0.94440001, 0.32569999, -0.20070003,
    0.96550000, 0.32570001, -0.00000002,
    0.94440001, 0.32570004, 0.20069997,
    0.88200003, 0.32570004, 0.39269996,
    0.78109998, 0.32570004, 0.56750000,
    0.64600003, 0.32570007, 0.71749997,
    0.48269999, 0.32570007, 0.83609998,
    0.29830000, 0.32570007, 0.91820002,
    0.10090000, 0.32570007, 0.96020001,
    -0.10090000, 0.32570007, 0.96020001,
    -0.29830000, 0.32570007, 0.91820002,
    -0.48269999, 0.32570007, 0.83609998,
    -0.64600003, 0.32570007, 0.71749997,
    -0.78109998, 0.32570004, 0.56750000,
    -0.88200003, 0.32570004, 0.39269996,
    -0.95810002, 0.28560004, 0.20359999,
    -0.98430002, 0.24339999, -0.00000002,
    -0.98430002, 0.24339999, -0.00000002,
    -0.98430002, 0.24339999, -0.00000002,
    -0.96270001, 0.24339998, -0.20460002,
    -0.96270001, 0.24339998, -0.20460002,
    -0.89480001, 0.28559998, -0.39840004,
    -0.79240000, 0.28559998, -0.57569999,
    -0.65539998, 0.28559995, -0.72790003,
    -0.48969999, 0.28559995, -0.84829998,
    -0.30270001, 0.28559995, -0.93159997,
    -0.10240000, 0.28559995, -0.97409999,
    0.10240000, 0.28559995, -0.97409999,
    0.30270001, 0.28559995, -0.93159997,
    0.48969999, 0.28559995, -0.84829998,
    0.65539998, 0.28559995, -0.72790003,
    0.79240000, 0.28559998, -0.57569999,
    0.89480001, 0.28559998, -0.39840004,
    0.95810002, 0.28559998, -0.20370002,
    0.97950000, 0.28560001, -0.00000002,
    0.95810002, 0.28560004, 0.20359999,
    0.89480001, 0.28560004, 0.39839998,
    0.79240000, 0.28560004, 0.57569999,
    0.65539998, 0.28560007, 0.72790003,
    0.48969999, 0.28560007, 0.84829998,
    0.30270001, 0.28560007, 0.93159997,
    0.10240000, 0.28560007, 0.97409999,
    -0.10240000, 0.28560007, 0.97409999,
    -0.30270001, 0.28560007, 0.93159997,
    -0.48980001, 0.28560007, 0.84829998,
    -0.65539998, 0.28560007, 0.72790003,
    -0.79240000, 0.28560004, 0.57569999,
    -0.89480001, 0.28560004, 0.39839998,
    -0.96270001, 0.24340001, 0.20459999,
    -0.96270001, 0.24340001, 0.20459999,
    -0.98430002, 0.21650000, -0.00000002,
    -0.98430002, 0.21650000, -0.00000002,
    -0.96270001, 0.21649998, -0.20460002,
    -0.89920002, 0.24339996, -0.40030003,
    -0.89920002, 0.24339996, -0.40030003,
    -0.79629999, 0.24339995, -0.57849997,
    -0.79629999, 0.24339995, -0.57849997,
    -0.65859997, 0.24339993, -0.73140001,
    -0.65859997, 0.24339993, -0.73140001,
    -0.49210000, 0.24339993, -0.85240000,
    -0.49210000, 0.24339993, -0.85240000,
    -0.30419999, 0.24339992, -0.93610001,
    -0.30419999, 0.24339992, -0.93610001,
    -0.10290000, 0.24339992, -0.97890002,
    -0.10290000, 0.24339992, -0.97890002,
    0.10290000, 0.24339992, -0.97890002,
    0.10290000, 0.24339992, -0.97890002,
    0.30419999, 0.24339992, -0.93610001,
    0.30419999, 0.24339992, -0.93610001,
    0.49210000, 0.24339993, -0.85240000,
    0.49210000, 0.24339993, -0.85240000,
    0.65859997, 0.24339993, -0.73140001,
    0.65859997, 0.24339993, -0.73140001,
    0.79629999, 0.24339995, -0.57849997,
    0.79629999, 0.24339995, -0.57849997,
    0.89920002, 0.24339996, -0.40030003,
    0.89920002, 0.24339996, -0.40030003,
    0.96270001, 0.24339998, -0.20460002,
    0.96270001, 0.24339998, -0.20460002,
    0.98430002, 0.24339999, -0.00000002,
    0.98430002, 0.24339999, -0.00000002,
    0.96270001, 0.24340001, 0.20459999,
    0.96270001, 0.24340001, 0.20459999,
    0.89920002, 0.24340002, 0.40029997,
    0.89920002, 0.24340002, 0.40029997,
    0.79629999, 0.24340004, 0.57849997,
    0.79629999, 0.24340004, 0.57849997,
    0.65859997, 0.24340005, 0.73140001,
    0.65859997, 0.24340005, 0.73140001,
    0.49210000, 0.24340005, 0.85240000,
    0.49210000, 0.24340005, 0.85240000,
    0.30410001, 0.24340007, 0.93610001,
    0.30410001, 0.24340007, 0.93610001,
    0.10290000, 0.24340007, 0.97890002,
    0.10290000, 0.24340007, 0.97890002,
    -0.10290000, 0.24340007, 0.97890002,
    -0.10290000, 0.24340007, 0.97890002,
    -0.30419999, 0.24340007, 0.93610001,
    -0.30419999, 0.24340007, 0.93610001,
    -0.49210000, 0.24340005, 0.85240000,
    -0.49210000, 0.24340005, 0.85240000,
    -0.65859997, 0.24340005, 0.73140001,
    -0.65859997, 0.24340005, 0.73140001,
    -0.79629999, 0.24340004, 0.57849997,
    -0.79629999, 0.24340004, 0.57849997,
    -0.89920002, 0.24340002, 0.40029997,
    -0.89920002, 0.24340002, 0.40029997,
    -0.96270001, 0.21650001, 0.20459999,
    -0.98430002, 0.18960001, -0.00000001,
    -0.98430002, 0.18960001, -0.00000001,
    -0.98430002, 0.18960001, -0.00000001,
    -0.96270001, 0.18959999, -0.20460002,
    -0.96270001, 0.18959999, -0.20460002,
    -0.89920002, 0.21649997, -0.40030003,
    -0.79629999, 0.21649995, -0.57849997,
    -0.65859997, 0.21649994, -0.73140001,
    -0.49210000, 0.21649994, -0.85240000,
    -0.30419999, 0.21649992, -0.93610001,
    -0.10290000, 0.21649992, -0.97890002,
    0.10290000, 0.21649992, -0.97890002,
    0.30419999, 0.21649992, -0.93610001,
    0.49210000, 0.21649994, -0.85240000,
    0.65859997, 0.21649994, -0.73140001,
    0.79629999, 0.21649995, -0.57849997,
    0.89920002, 0.21649997, -0.40030003,
    0.96270001, 0.21649998, -0.20460002,
    0.98430002, 0.21650000, -0.00000002,
    0.96270001, 0.21650001, 0.20459999,
    0.89920002, 0.21650003, 0.40029997,
    0.79629999, 0.21650004, 0.57849997,
    0.65859997, 0.21650006, 0.73140001,
    0.49210000, 0.21650006, 0.85240000,
    0.30410001, 0.21650007, 0.93610001,
    0.10290000, 0.21650007, 0.97890002,
    -0.10290000, 0.21650007, 0.97890002,
    -0.30419999, 0.21650007, 0.93610001,
    -0.49210000, 0.21650006, 0.85240000,
    -0.65859997, 0.21650006, 0.73140001,
    -0.79629999, 0.21650004, 0.57849997,
    -0.89920002, 0.21650003, 0.40029997,
    -0.96270001, 0.18960002, 0.20459999,
    -0.96270001, 0.18960002, 0.20459999,
    -0.97950000, 0.14740001, -0.00000001,
    -0.95810002, 0.14739999, -0.20370002,
    -0.89920002, 0.18959998, -0.40030000,
    -0.89920002, 0.18959998, -0.40030000,
    -0.79629999, 0.18959996, -0.57849997,
    -0.79629999, 0.18959996, -0.57849997,
    -0.65859997, 0.18959995, -0.73140001,
    -0.65859997, 0.18959995, -0.73140001,
    -0.49210000, 0.18959995, -0.85240000,
    -0.49210000, 0.18959995, -0.85240000,
    -0.30419999, 0.18959993, -0.93610001,
    -0.30419999, 0.18959993, -0.93610001,
    -0.10290000, 0.18959993, -0.97890002,
    -0.10290000, 0.18959993, -0.97890002,
    0.10290000, 0.18959993, -0.97890002,
    0.10290000, 0.18959993, -0.97890002,
    0.30419999, 0.18959993, -0.93610001,
    0.30419999, 0.18959993, -0.93610001,
    0.49210000, 0.18959995, -0.85240000,
    0.49210000, 0.18959995, -0.85240000,
    0.65859997, 0.18959995, -0.73140001,
    0.65859997, 0.18959995, -0.73140001,
    0.79629999, 0.18959996, -0.57849997,
    0.79629999, 0.18959996, -0.57849997,
    0.89920002, 0.18959998, -0.40030000,
    0.89920002, 0.18959998, -0.40030000,
    0.96270001, 0.18959999, -0.20460002,
    0.96270001, 0.18959999, -0.20460002,
    0.98430002, 0.18960001, -0.00000001,
    0.98430002, 0.18960001, -0.00000001,
    0.96270001, 0.18960002, 0.20459999,
    0.96270001, 0.18960002, 0.20459999,
    0.89920002, 0.18960004, 0.40030000,
    0.89920002, 0.18960004, 0.40030000,
    0.79629999, 0.18960005, 0.57849997,
    0.79629999, 0.18960005, 0.57849997,
    0.65859997, 0.18960007, 0.73140001,
    0.65859997, 0.18960007, 0.73140001,
    0.49210000, 0.18960007, 0.85240000,
    0.49210000, 0.18960007, 0.85240000,
    0.30410001, 0.18960008, 0.93610001,
    0.30410001, 0.18960008, 0.93610001,
    0.10290000, 0.18960008, 0.97890002,
    0.10290000, 0.18960008, 0.97890002,
    -0.10290000, 0.18960008, 0.97890002,
    -0.10290000, 0.18960008, 0.97890002,
    -0.30419999, 0.18960008, 0.93610001,
    -0.30419999, 0.18960008, 0.93610001,
    -0.49210000, 0.18960007, 0.85240000,
    -0.49210000, 0.18960007, 0.85240000,
    -0.65859997, 0.18960007, 0.73140001,
    -0.65859997, 0.18960007, 0.73140001,
    -0.79629999, 0.18960005, 0.57849997,
    -0.79629999, 0.18960005, 0.57849997,
    -0.89920002, 0.18960004, 0.40030000,
    -0.89920002, 0.18960004, 0.40030000,
    -0.95810002, 0.14740002, 0.20359999,
    -0.96550000, 0.10740000, -0.00000001,
    -0.94440001, 0.10739999, -0.20070001,
    -0.89480001, 0.14739998, -0.39840001,
    -0.79240000, 0.14739996, -0.57569999,
    -0.65539998, 0.14739995, -0.72790003,
    -0.48969999, 0.14739995, -0.84829998,
    -0.30270001, 0.14739993, -0.93159997,
    -0.10240000, 0.14739993, -0.97409999,
    0.10240000, 0.14739993, -0.97409999,
    0.30270001, 0.14739993, -0.93159997,
    0.48969999, 0.14739995, -0.84829998,
    0.65539998, 0.14739995, -0.72790003,
    0.79240000, 0.14739996, -0.57569999,
    0.89480001, 0.14739998, -0.39840001,
    0.95810002, 0.14739999, -0.20370002,
    0.97950000, 0.14740001, -0.00000001,
    0.95810002, 0.14740002, 0.20359999,
    0.89480001, 0.14740004, 0.39840001,
    0.79240000, 0.14740005, 0.57569999,
    0.65539998, 0.14740007, 0.72790003,
    0.48969999, 0.14740007, 0.84829998,
    0.30270001, 0.14740008, 0.93159997,
    0.10240000, 0.14740008, 0.97409999,
    -0.10240000, 0.14740008, 0.97409999,
    -0.30270001, 0.14740008, 0.93159997,
    -0.48980001, 0.14740007, 0.84829998,
    -0.65539998, 0.14740007, 0.72790003,
    -0.79240000, 0.14740005, 0.57569999,
    -0.89480001, 0.14740004, 0.39840001,
    -0.94440001, 0.10740001, 0.20069999,
    -0.94290000, 0.07140000, -0.00000001,
    -0.92229998, 0.07139999, -0.19599999,
    -0.88200003, 0.10739997, -0.39269999,
    -0.78109998, 0.10739996, -0.56750000,
    -0.64600003, 0.10739995, -0.71749997,
    -0.48269999, 0.10739994, -0.83609998,
    -0.29830000, 0.10739993, -0.91820002,
    -0.10090000, 0.10739993, -0.96020001,
    0.10090000, 0.10739993, -0.96020001,
    0.29830000, 0.10739993, -0.91820002,
    0.48269999, 0.10739994, -0.83609998,
    0.64600003, 0.10739995, -0.71749997,
    0.78109998, 0.10739996, -0.56750000,
    0.88200003, 0.10739997, -0.39269999,
    0.94440001, 0.10739999, -0.20070001,
    0.96550000, 0.10740000, -0.00000001,
    0.94440001, 0.10740001, 0.20069999,
    0.88200003, 0.10740003, 0.39269999,
    0.78109998, 0.10740004, 0.56750000,
    0.64600003, 0.10740005, 0.71749997,
    0.48269999, 0.10740006, 0.83609998,
    0.29830000, 0.10740007, 0.91820002,
    0.10090000, 0.10740007, 0.96020001,
    -0.10090000, 0.10740007, 0.96020001,
    -0.29830000, 0.10740007, 0.91820002,
    -0.48269999, 0.10740006, 0.83609998,
    -0.64600003, 0.10740005, 0.71749997,
    -0.78109998, 0.10740004, 0.56750000,
    -0.88200003, 0.10740003, 0.39269999,
    -0.92229998, 0.07140002, 0.19599999,
    -0.91280001, 0.04140000, -0.00000000,
    -0.89289999, 0.04139999, -0.18979999,
    -0.86140001, 0.07139997, -0.38350001,
    -0.76279998, 0.07139996, -0.55419999,
    -0.63090003, 0.07139995, -0.70069999,
    -0.47139999, 0.07139994, -0.81660002,
    -0.29139999, 0.07139993, -0.89670002,
    -0.09860000, 0.07139993, -0.93769997,
    0.09860000, 0.07139993, -0.93769997,
    0.29139999, 0.07139993, -0.89670002,
    0.47139999, 0.07139994, -0.81660002,
    0.63090003, 0.07139995, -0.70069999,
    0.76279998, 0.07139996, -0.55419999,
    0.86140001, 0.07139997, -0.38350001,
    0.92229998, 0.07139999, -0.19599999,
    0.94290000, 0.07140000, -0.00000001,
    0.92229998, 0.07140002, 0.19599999,
    0.86140001, 0.07140003, 0.38350001,
    0.76279998, 0.07140005, 0.55419999,
    0.63090003, 0.07140005, 0.70069999,
    0.47139999, 0.07140006, 0.81660002,
    0.29139999, 0.07140007, 0.89670002,
    0.09860000, 0.07140008, 0.93769997,
    -0.09860000, 0.07140008, 0.93769997,
    -0.29139999, 0.07140007, 0.89670002,
    -0.47139999, 0.07140006, 0.81660002,
    -0.63090003, 0.07140005, 0.70069999,
    -0.76279998, 0.07140005, 0.55419999,
    -0.86140001, 0.07140003, 0.38350001,
    -0.89289999, 0.04140002, 0.18979999,
    -0.87690002, 0.01880000, -0.00000000,
    -0.85769999, 0.01879999, -0.18230000,
    -0.83389997, 0.04139997, -0.37130001,
    -0.73850000, 0.04139996, -0.53659999,
    -0.61080003, 0.04139995, -0.67839998,
    -0.45640001, 0.04139994, -0.79060000,
    -0.28209999, 0.04139993, -0.86820000,
    -0.09540000, 0.04139993, -0.90789998,
    0.09540000, 0.04139993, -0.90789998,
    0.28209999, 0.04139993, -0.86820000,
    0.45640001, 0.04139994, -0.79060000,
    0.61080003, 0.04139995, -0.67839998,
    0.73850000, 0.04139996, -0.53659999,
    0.83389997, 0.04139997, -0.37130001,
    0.89289999, 0.04139999, -0.18979999,
    0.91280001, 0.04140000, -0.00000000,
    0.89289999, 0.04140002, 0.18979999,
    0.83389997, 0.04140003, 0.37130001,
    0.73850000, 0.04140004, 0.53659999,
    0.61080003, 0.04140005, 0.67839998,
    0.45640001, 0.04140006, 0.79049999,
    0.28209999, 0.04140007, 0.86820000,
    0.09540000, 0.04140007, 0.90780002,
    -0.09540000, 0.04140007, 0.90780002,
    -0.28209999, 0.04140007, 0.86820000,
    -0.45640001, 0.04140006, 0.79049999,
    -0.61080003, 0.04140005, 0.67839998,
    -0.73850000, 0.04140004, 0.53659999,
    -0.83389997, 0.04140003, 0.37130001,
    -0.85769999, 0.01880001, 0.18230000,
    -0.83679998, 0.00480000, -0.00000000,
    -0.81849998, 0.00479999, -0.17399999,
    -0.80110002, 0.01879997, -0.35670000,
    -0.70940000, 0.01879996, -0.51539999,
    -0.58679998, 0.01879995, -0.65170002,
    -0.43840000, 0.01879994, -0.75940001,
    -0.27100000, 0.01879994, -0.83399999,
    -0.09170000, 0.01879993, -0.87210000,
    0.09170000, 0.01879993, -0.87210000,
    0.27100000, 0.01879994, -0.83399999,
    0.43840000, 0.01879994, -0.75940001,
    0.58679998, 0.01879995, -0.65170002,
    0.70940000, 0.01879996, -0.51539999,
    0.80110002, 0.01879997, -0.35670000,
    0.85769999, 0.01879999, -0.18230000,
    0.87690002, 0.01880000, -0.00000000,
    0.85769999, 0.01880001, 0.18230000,
    0.80110002, 0.01880003, 0.35670000,
    0.70940000, 0.01880004, 0.51539999,
    0.58679998, 0.01880005, 0.65170002,
    0.43840000, 0.01880006, 0.75940001,
    0.27100000, 0.01880006, 0.83399999,
    0.09170000, 0.01880006, 0.87210000,
    -0.09170000, 0.01880006, 0.87210000,
    -0.27100000, 0.01880006, 0.83399999,
    -0.43840000, 0.01880006, 0.75940001,
    -0.58679998, 0.01880005, 0.65170002,
    -0.70940000, 0.01880004, 0.51539999,
    -0.80110002, 0.01880003, 0.35670000,
    -0.81849998, 0.00480001, 0.17399999,
    -0.79460001, 0.00000000, 0.00000000,
    -0.77719998, -0.00000001, -0.16520000,
    -0.76450002, 0.00479997, -0.34040001,
    -0.67699999, 0.00479996, -0.49190000,
    -0.55989999, 0.00479995, -0.62190002,
    -0.41839999, 0.00479995, -0.72469997,
    -0.25860000, 0.00479994, -0.79589999,
    -0.08750000, 0.00479994, -0.83219999,
    0.08750000, 0.00479994, -0.83219999,
    0.25860000, 0.00479994, -0.79589999,
    0.41839999, 0.00479995, -0.72469997,
    0.55989999, 0.00479995, -0.62190002,
    0.67699999, 0.00479996, -0.49190000,
    0.76450002, 0.00479997, -0.34040001,
    0.81849998, 0.00479999, -0.17399999,
    0.83679998, 0.00480000, -0.00000000,
    0.81849998, 0.00480001, 0.17399999,
    0.76450002, 0.00480003, 0.34040001,
    0.67699999, 0.00480004, 0.49190000,
    0.55989999, 0.00480005, 0.62190002,
    0.41839999, 0.00480005, 0.72469997,
    0.25860000, 0.00480006, 0.79579997,
    0.08750000, 0.00480006, 0.83219999,
    -0.08750000, 0.00480006, 0.83219999,
    -0.25860000, 0.00480006, 0.79579997,
    -0.41839999, 0.00480005, 0.72469997,
    -0.55989999, 0.00480005, 0.62190002,
    -0.67699999, 0.00480004, 0.49190000,
    -0.76450002, 0.00480003, 0.34040001,
    -0.77719998, 0.00000001, 0.16520000,
    0.00000000, 0.00000000, 0.00000000,
    -0.72589999, -0.00000002, -0.32319999,
    -0.64289999, -0.00000004, -0.46709999,
    -0.53170002, -0.00000004, -0.59050000,
    -0.39730000, -0.00000005, -0.68820000,
    -0.24550000, -0.00000006, -0.75569999,
    -0.08310000, -0.00000006, -0.79030001,
    0.08310000, -0.00000006, -0.79030001,
    0.24550000, -0.00000006, -0.75569999,
    0.39730000, -0.00000005, -0.68820000,
    0.53170002, -0.00000004, -0.59050000,
    0.64289999, -0.00000004, -0.46709999,
    0.72589999, -0.00000002, -0.32319999,
    0.77719998, -0.00000001, -0.16520000,
    0.79460001, 0.00000000, 0.00000000,
    0.77719998, 0.00000001, 0.16520000,
    0.72589999, 0.00000002, 0.32319999,
    0.64289999, 0.00000004, 0.46709999,
    0.53170002, 0.00000004, 0.59050000,
    0.39730000, 0.00000005, 0.68809998,
    0.24550000, 0.00000006, 0.75569999,
    0.08310000, 0.00000006, 0.79030001,
    -0.08310000, 0.00000006, 0.79030001,
    -0.24550000, 0.00000006, 0.75569999,
    -0.39730000, 0.00000005, 0.68809998,
    -0.53170002, 0.00000004, 0.59050000,
    -0.64289999, 0.00000004, 0.46709999,
    -0.72589999, 0.00000002, 0.32319999,
    -0.48120001, 0.35769996, -0.45810002,
    -0.63400000, 0.35769999, -0.14900003,
    -0.57969999, 0.35770002, 0.26199996,
    -0.30450001, 0.35769999, -0.02670003,
    -0.07010000, 0.35769999, 0.11259997,
    -0.10750000, 0.35770002, 0.29259998,
    -0.29769999, 0.35770002, 0.49299997,
    0.54130000, 0.35769996, -0.39700004,
    0.31029999, 0.35769999, 0.01069997,
    0.31029999, 0.35769999, 0.01069997,
    0.02160000, 0.35769999, 0.16349997,
    0.02160000, 0.35769999, 0.16349997,
    0.67720002, 0.35769999, -0.11500003,
    0.52770001, 0.35770002, 0.30619997,
    0.25929999, 0.35770002, 0.54060000,
    0.07250000, 0.35770002, 0.36729997,
  ]),
  indices: new Uint16Array([
    0, 1, 2, 0, 2, 3, 17, 45, 617, 17, 617, 616,
    61, 62, 1, 61, 1, 0, 1, 63, 64, 1, 64, 2,
    3, 2, 65, 3, 65, 4, 4, 65, 66, 4, 66, 5,
    5, 66, 67, 5, 67, 6, 6, 67, 68, 6, 68, 7,
    7, 68, 69, 7, 69, 8, 8, 69, 70, 8, 70, 9,
    9, 70, 71, 9, 71, 10, 10, 71, 72, 10, 72, 11,
    11, 72, 73, 11, 73, 12, 12, 73, 74, 12, 74, 13,
    13, 74, 75, 13, 75, 14, 14, 75, 76, 14, 76, 15,
    15, 76, 77, 15, 77, 16, 16, 77, 78, 16, 78, 47,
    47, 78, 79, 47, 79, 48, 48, 79, 80, 48, 80, 49,
    49, 80, 81, 49, 81, 50, 50, 81, 82, 50, 82, 51,
    51, 82, 83, 51, 83, 52, 52, 83, 84, 52, 84, 53,
    53, 84, 85, 53, 85, 54, 54, 85, 86, 54, 86, 55,
    55, 86, 87, 55, 87, 56, 56, 87, 88, 56, 88, 57,
    57, 88, 89, 57, 89, 58, 58, 89, 90, 58, 90, 59,
    59, 90, 91, 59, 91, 60, 60, 91, 62, 60, 62, 61,
    62, 92, 63, 62, 63, 1, 63, 93, 94, 63, 94, 64,
    2, 64, 95, 2, 95, 65, 65, 95, 96, 65, 96, 66,
    66, 96, 97, 66, 97, 67, 67, 97, 98, 67, 98, 68,
    68, 98, 99, 68, 99, 69, 69, 99, 100, 69, 100, 70,
    70, 100, 101, 70, 101, 71, 71, 101, 102, 71, 102, 72,
    72, 102, 103, 72, 103, 73, 73, 103, 104, 73, 104, 74,
    74, 104, 105, 74, 105, 75, 75, 105, 106, 75, 106, 76,
    76, 106, 107, 76, 107, 77, 77, 107, 108, 77, 108, 78,
    78, 108, 109, 78, 109, 79, 79, 109, 110, 79, 110, 80,
    80, 110, 111, 80, 111, 81, 81, 111, 112, 81, 112, 82,
    82, 112, 113, 82, 113, 83, 83, 113, 114, 83, 114, 84,
    84, 114, 115, 84, 115, 85, 85, 115, 116, 85, 116, 86,
    86, 116, 117, 86, 117, 87, 87, 117, 118, 87, 118, 88,
    88, 118, 119, 88, 119, 89, 89, 119, 120, 89, 120, 90,
    90, 120, 121, 90, 121, 91, 91, 121, 92, 91, 92, 62,
    92, 122, 93, 92, 93, 63, 93, 123, 124, 93, 124, 94,
    64, 94, 125, 64, 125, 95, 95, 125, 126, 95, 126, 96,
    96, 126, 127, 96, 127, 97, 97, 127, 128, 97, 128, 98,
    98, 128, 129, 98, 129, 99, 99, 129, 130, 99, 130, 100,
    100, 130, 131, 100, 131, 101, 101, 131, 132, 101, 132, 102,
    102, 132, 133, 102, 133, 103, 103, 133, 134, 103, 134, 104,
    104, 134, 135, 104, 135, 105, 105, 135, 136, 105, 136, 106,
    106, 136, 137, 106, 137, 107, 107, 137, 138, 107, 138, 108,
    108, 138, 139, 108, 139, 109, 109, 139, 140, 109, 140, 110,
    110, 140, 141, 110, 141, 111, 111, 141, 142, 111, 142, 112,
    112, 142, 143, 112, 143, 113, 113, 143, 144, 113, 144, 114,
    114, 144, 145, 114, 145, 115, 115, 145, 146, 115, 146, 116,
    116, 146, 147, 116, 147, 117, 117, 147, 148, 117, 148, 118,
    118, 148, 149, 118, 149, 119, 119, 149, 150, 119, 150, 120,
    120, 150, 151, 120, 151, 121, 121, 151, 122, 121, 122, 92,
    122, 152, 123, 122, 123, 93, 123, 153, 154, 123, 154, 124,
    94, 124, 155, 94, 155, 125, 125, 155, 156, 125, 156, 126,
    126, 156, 157, 126, 157, 127, 127, 157, 158, 127, 158, 128,
    128, 158, 159, 128, 159, 129, 129, 159, 160, 129, 160, 130,
    130, 160, 161, 130, 161, 131, 131, 161, 162, 131, 162, 132,
    132, 162, 163, 132, 163, 133, 133, 163, 164, 133, 164, 134,
    134, 164, 165, 134, 165, 135, 135, 165, 166, 135, 166, 136,
    136, 166, 167, 136, 167, 137, 137, 167, 168, 137, 168, 138,
    138, 168, 169, 138, 169, 139, 139, 169, 170, 139, 170, 140,
    140, 170, 171, 140, 171, 141, 141, 171, 172, 141, 172, 142,
    142, 172, 173, 142, 173, 143, 143, 173, 174, 143, 174, 144,
    144, 174, 175, 144, 175, 145, 145, 175, 176, 145, 176, 146,
    146, 176, 177, 146, 177, 147, 147, 177, 178, 147, 178, 148,
    148, 178, 179, 148, 179, 149, 149, 179, 180, 149, 180, 150,
    150, 180, 181, 150, 181, 151, 151, 181, 152, 151, 152, 122,
    152, 182, 153, 152, 153, 123, 153, 183, 184, 153, 184, 154,
    124, 154, 185, 124, 185, 155, 155, 185, 186, 155, 186, 156,
    156, 186, 187, 156, 187, 157, 157, 187, 188, 157, 188, 158,
    158, 188, 189, 158, 189, 159, 159, 189, 190, 159, 190, 160,
    160, 190, 191, 160, 191, 161, 161, 191, 192, 161, 192, 162,
    162, 192, 193, 162, 193, 163, 163, 193, 194, 163, 194, 164,
    164, 194, 195, 164, 195, 165, 165, 195, 196, 165, 196, 166,
    166, 196, 197, 166, 197, 167, 167, 197, 198, 167, 198, 168,
    168, 198, 199, 168, 199, 169, 169, 199, 200, 169, 200, 170,
    170, 200, 201, 170, 201, 171, 171, 201, 202, 171, 202, 172,
    172, 202, 203, 172, 203, 173, 173, 203, 204, 173, 204, 174,
    174, 204, 205, 174, 205, 175, 175, 205, 206, 175, 206, 176,
    176, 206, 207, 176, 207, 177, 177, 207, 208, 177, 208, 178,
    178, 208, 209, 178, 209, 179, 179, 209, 210, 179, 210, 180,
    180, 210, 211, 180, 211, 181, 181, 211, 182, 181, 182, 152,
    182, 212, 183, 182, 183, 153, 183, 215, 217, 183, 217, 184,
    154, 184, 218, 154, 218, 185, 185, 218, 219, 185, 219, 186,
    186, 219, 220, 186, 220, 187, 187, 220, 221, 187, 221, 188,
    188, 221, 222, 188, 222, 189, 189, 222, 223, 189, 223, 190,
    190, 223, 224, 190, 224, 191, 191, 224, 225, 191, 225, 192,
    192, 225, 226, 192, 226, 193, 193, 226, 227, 193, 227, 194,
    194, 227, 228, 194, 228, 195, 195, 228, 229, 195, 229, 196,
    196, 229, 230, 196, 230, 197, 197, 230, 231, 197, 231, 198,
    198, 231, 232, 198, 232, 199, 199, 232, 233, 199, 233, 200,
    200, 233, 234, 200, 234, 201, 201, 234, 235, 201, 235, 202,
    202, 235, 236, 202, 236, 203, 203, 236, 237, 203, 237, 204,
    204, 237, 238, 204, 238, 205, 205, 238, 239, 205, 239, 206,
    206, 239, 240, 206, 240, 207, 207, 240, 241, 207, 241, 208,
    208, 241, 242, 208, 242, 209, 209, 242, 243, 209, 243, 210,
    210, 243, 244, 210, 244, 211, 211, 244, 212, 211, 212, 182,
    212, 246, 215, 212, 215, 183, 213, 247, 249, 213, 249, 216,
    184, 217, 251, 184, 251, 218, 218, 251, 253, 218, 253, 219,
    219, 253, 255, 219, 255, 220, 220, 255, 257, 220, 257, 221,
    221, 257, 259, 221, 259, 222, 222, 259, 261, 222, 261, 223,
    223, 261, 263, 223, 263, 224, 224, 263, 265, 224, 265, 225,
    225, 265, 266, 225, 266, 226, 226, 266, 268, 226, 268, 227,
    227, 268, 270, 227, 270, 228, 228, 270, 272, 228, 272, 229,
    229, 272, 274, 229, 274, 230, 230, 274, 276, 230, 276, 231,
    231, 276, 278, 231, 278, 232, 232, 278, 280, 232, 280, 233,
    233, 280, 282, 233, 282, 234, 234, 282, 284, 234, 284, 235,
    235, 284, 286, 235, 286, 236, 236, 286, 288, 236, 288, 237,
    237, 288, 290, 237, 290, 238, 238, 290, 292, 238, 292, 239,
    239, 292, 294, 239, 294, 240, 240, 294, 296, 240, 296, 241,
    241, 296, 298, 241, 298, 242, 242, 298, 301, 242, 301, 243,
    243, 301, 303, 243, 303, 244, 244, 303, 246, 244, 246, 212,
    245, 304, 248, 245, 248, 214, 247, 305, 308, 247, 308, 249,
    216, 249, 310, 216, 310, 250, 250, 310, 311, 250, 311, 252,
    252, 311, 312, 252, 312, 254, 254, 312, 313, 254, 313, 256,
    256, 313, 314, 256, 314, 258, 258, 314, 315, 258, 315, 260,
    260, 315, 316, 260, 316, 262, 262, 316, 317, 262, 317, 264,
    264, 317, 318, 264, 318, 267, 267, 318, 319, 267, 319, 269,
    269, 319, 320, 269, 320, 271, 271, 320, 321, 271, 321, 273,
    273, 321, 322, 273, 322, 275, 275, 322, 323, 275, 323, 277,
    277, 323, 324, 277, 324, 279, 279, 324, 325, 279, 325, 281,
    281, 325, 326, 281, 326, 283, 283, 326, 327, 283, 327, 285,
    285, 327, 328, 285, 328, 287, 287, 328, 329, 287, 329, 289,
    289, 329, 330, 289, 330, 291, 291, 330, 331, 291, 331, 293,
    293, 331, 332, 293, 332, 295, 295, 332, 333, 295, 333, 297,
    297, 333, 334, 297, 334, 299, 299, 334, 335, 299, 335, 300,
    300, 335, 336, 300, 336, 302, 302, 336, 304, 302, 304, 245,
    304, 337, 307, 304, 307, 248, 306, 339, 340, 306, 340, 309,
    249, 308, 341, 249, 341, 310, 310, 341, 343, 310, 343, 311,
    311, 343, 345, 311, 345, 312, 312, 345, 347, 312, 347, 313,
    313, 347, 349, 313, 349, 314, 314, 349, 351, 314, 351, 315,
    315, 351, 353, 315, 353, 316, 316, 353, 355, 316, 355, 317,
    317, 355, 358, 317, 358, 318, 318, 358, 360, 318, 360, 319,
    319, 360, 362, 319, 362, 320, 320, 362, 364, 320, 364, 321,
    321, 364, 366, 321, 366, 322, 322, 366, 368, 322, 368, 323,
    323, 368, 370, 323, 370, 324, 324, 370, 372, 324, 372, 325,
    325, 372, 374, 325, 374, 326, 326, 374, 376, 326, 376, 327,
    327, 376, 378, 327, 378, 328, 328, 378, 380, 328, 380, 329,
    329, 380, 382, 329, 382, 330, 330, 382, 384, 330, 384, 331,
    331, 384, 386, 331, 386, 332, 332, 386, 388, 332, 388, 333,
    333, 388, 390, 333, 390, 334, 334, 390, 391, 334, 391, 335,
    335, 391, 393, 335, 393, 336, 336, 393, 337, 336, 337, 304,
    338, 395, 339, 338, 339, 306, 339, 396, 397, 339, 397, 340,
    309, 340, 398, 309, 398, 342, 342, 398, 399, 342, 399, 344,
    344, 399, 400, 344, 400, 346, 346, 400, 401, 346, 401, 348,
    348, 401, 402, 348, 402, 350, 350, 402, 403, 350, 403, 352,
    352, 403, 404, 352, 404, 354, 354, 404, 405, 354, 405, 356,
    356, 405, 406, 356, 406, 357, 357, 406, 407, 357, 407, 359,
    359, 407, 408, 359, 408, 361, 361, 408, 409, 361, 409, 363,
    363, 409, 410, 363, 410, 365, 365, 410, 411, 365, 411, 367,
    367, 411, 412, 367, 412, 369, 369, 412, 413, 369, 413, 371,
    371, 413, 414, 371, 414, 373, 373, 414, 415, 373, 415, 375,
    375, 415, 416, 375, 416, 377, 377, 416, 417, 377, 417, 379,
    379, 417, 418, 379, 418, 381, 381, 418, 419, 381, 419, 383,
    383, 419, 420, 383, 420, 385, 385, 420, 421, 385, 421, 387,
    387, 421, 422, 387, 422, 389, 389, 422, 423, 389, 423, 392,
    392, 423, 424, 392, 424, 394, 394, 424, 395, 394, 395, 338,
    395, 425, 396, 395, 396, 339, 396, 426, 427, 396, 427, 397,
    340, 397, 428, 340, 428, 398, 398, 428, 429, 398, 429, 399,
    399, 429, 430, 399, 430, 400, 400, 430, 431, 400, 431, 401,
    401, 431, 432, 401, 432, 402, 402, 432, 433, 402, 433, 403,
    403, 433, 434, 403, 434, 404, 404, 434, 435, 404, 435, 405,
    405, 435, 436, 405, 436, 406, 406, 436, 437, 406, 437, 407,
    407, 437, 438, 407, 438, 408, 408, 438, 439, 408, 439, 409,
    409, 439, 440, 409, 440, 410, 410, 440, 441, 410, 441, 411,
    411, 441, 442, 411, 442, 412, 412, 442, 443, 412, 443, 413,
    413, 443, 444, 413, 444, 414, 414, 444, 445, 414, 445, 415,
    415, 445, 446, 415, 446, 416, 416, 446, 447, 416, 447, 417,
    417, 447, 448, 417, 448, 418, 418, 448, 449, 418, 449, 419,
    419, 449, 450, 419, 450, 420, 420, 450, 451, 420, 451, 421,
    421, 451, 452, 421, 452, 422, 422, 452, 453, 422, 453, 423,
    423, 453, 454, 423, 454, 424, 424, 454, 425, 424, 425, 395,
    425, 455, 426, 425, 426, 396, 426, 456, 457, 426, 457, 427,
    397, 427, 458, 397, 458, 428, 428, 458, 459, 428, 459, 429,
    429, 459, 460, 429, 460, 430, 430, 460, 461, 430, 461, 431,
    431, 461, 462, 431, 462, 432, 432, 462, 463, 432, 463, 433,
    433, 463, 464, 433, 464, 434, 434, 464, 465, 434, 465, 435,
    435, 465, 466, 435, 466, 436, 436, 466, 467, 436, 467, 437,
    437, 467, 468, 437, 468, 438, 438, 468, 469, 438, 469, 439,
    439, 469, 470, 439, 470, 440, 440, 470, 471, 440, 471, 441,
    441, 471, 472, 441, 472, 442, 442, 472, 473, 442, 473, 443,
    443, 473, 474, 443, 474, 444, 444, 474, 475, 444, 475, 445,
    445, 475, 476, 445, 476, 446, 446, 476, 477, 446, 477, 447,
    447, 477, 478, 447, 478, 448, 448, 478, 479, 448, 479, 449,
    449, 479, 480, 449, 480, 450, 450, 480, 481, 450, 481, 451,
    451, 481, 482, 451, 482, 452, 452, 482, 483, 452, 483, 453,
    453, 483, 484, 453, 484, 454, 454, 484, 455, 454, 455, 425,
    455, 485, 456, 455, 456, 426, 456, 486, 487, 456, 487, 457,
    427, 457, 488, 427, 488, 458, 458, 488, 489, 458, 489, 459,
    459, 489, 490, 459, 490, 460, 460, 490, 491, 460, 491, 461,
    461, 491, 492, 461, 492, 462, 462, 492, 493, 462, 493, 463,
    463, 493, 494, 463, 494, 464, 464, 494, 495, 464, 495, 465,
    465, 495, 496, 465, 496, 466, 466, 496, 497, 466, 497, 467,
    467, 497, 498, 467, 498, 468, 468, 498, 499, 468, 499, 469,
    469, 499, 500, 469, 500, 470, 470, 500, 501, 470, 501, 471,
    471, 501, 502, 471, 502, 472, 472, 502, 503, 472, 503, 473,
    473, 503, 504, 473, 504, 474, 474, 504, 505, 474, 505, 475,
    475, 505, 506, 475, 506, 476, 476, 506, 507, 476, 507, 477,
    477, 507, 508, 477, 508, 478, 478, 508, 509, 478, 509, 479,
    479, 509, 510, 479, 510, 480, 480, 510, 511, 480, 511, 481,
    481, 511, 512, 481, 512, 482, 482, 512, 513, 482, 513, 483,
    483, 513, 514, 483, 514, 484, 484, 514, 485, 484, 485, 455,
    485, 515, 486, 485, 486, 456, 486, 516, 517, 486, 517, 487,
    457, 487, 518, 457, 518, 488, 488, 518, 519, 488, 519, 489,
    489, 519, 520, 489, 520, 490, 490, 520, 521, 490, 521, 491,
    491, 521, 522, 491, 522, 492, 492, 522, 523, 492, 523, 493,
    493, 523, 524, 493, 524, 494, 494, 524, 525, 494, 525, 495,
    495, 525, 526, 495, 526, 496, 496, 526, 527, 496, 527, 497,
    497, 527, 528, 497, 528, 498, 498, 528, 529, 498, 529, 499,
    499, 529, 530, 499, 530, 500, 500, 530, 531, 500, 531, 501,
    501, 531, 532, 501, 532, 502, 502, 532, 533, 502, 533, 503,
    503, 533, 534, 503, 534, 504, 504, 534, 535, 504, 535, 505,
    505, 535, 536, 505, 536, 506, 506, 536, 537, 506, 537, 507,
    507, 537, 538, 507, 538, 508, 508, 538, 539, 508, 539, 509,
    509, 539, 540, 509, 540, 510, 510, 540, 541, 510, 541, 511,
    511, 541, 542, 511, 542, 512, 512, 542, 543, 512, 543, 513,
    513, 543, 544, 513, 544, 514, 514, 544, 515, 514, 515, 485,
    515, 545, 516, 515, 516, 486, 516, 546, 547, 516, 547, 517,
    487, 517, 548, 487, 548, 518, 518, 548, 549, 518, 549, 519,
    519, 549, 550, 519, 550, 520, 520, 550, 551, 520, 551, 521,
    521, 551, 552, 521, 552, 522, 522, 552, 553, 522, 553, 523,
    523, 553, 554, 523, 554, 524, 524, 554, 555, 524, 555, 525,
    525, 555, 556, 525, 556, 526, 526, 556, 557, 526, 557, 527,
    527, 557, 558, 527, 558, 528, 528, 558, 559, 528, 559, 529,
    529, 559, 560, 529, 560, 530, 530, 560, 561, 530, 561, 531,
    531, 561, 562, 531, 562, 532, 532, 562, 563, 532, 563, 533,
    533, 563, 564, 533, 564, 534, 534, 564, 565, 534, 565, 535,
    535, 565, 566, 535, 566, 536, 536, 566, 567, 536, 567, 537,
    537, 567, 568, 537, 568, 538, 538, 568, 569, 538, 569, 539,
    539, 569, 570, 539, 570, 540, 540, 570, 571, 540, 571, 541,
    541, 571, 572, 541, 572, 542, 542, 572, 573, 542, 573, 543,
    543, 573, 574, 543, 574, 544, 544, 574, 545, 544, 545, 515,
    545, 575, 546, 545, 546, 516, 546, 576, 547, 517, 547, 577,
    517, 577, 548, 548, 577, 578, 548, 578, 549, 549, 578, 579,
    549, 579, 550, 550, 579, 580, 550, 580, 551, 551, 580, 581,
    551, 581, 552, 552, 581, 582, 552, 582, 553, 553, 582, 583,
    553, 583, 554, 554, 583, 584, 554, 584, 555, 555, 584, 585,
    555, 585, 556, 556, 585, 586, 556, 586, 557, 557, 586, 587,
    557, 587, 558, 558, 587, 588, 558, 588, 559, 559, 588, 589,
    559, 589, 560, 560, 589, 590, 560, 590, 561, 561, 590, 591,
    561, 591, 562, 562, 591, 592, 562, 592, 563, 563, 592, 593,
    563, 593, 564, 564, 593, 594, 564, 594, 565, 565, 594, 595,
    565, 595, 566, 566, 595, 596, 566, 596, 567, 567, 596, 597,
    567, 597, 568, 568, 597, 598, 568, 598, 569, 569, 598, 599,
    569, 599, 570, 570, 599, 600, 570, 600, 571, 571, 600, 601,
    571, 601, 572, 572, 601, 602, 572, 602, 573, 573, 602, 603,
    573, 603, 574, 574, 603, 575, 574, 575, 545, 575, 576, 546,
    547, 576, 577, 577, 576, 578, 578, 576, 579, 579, 576, 580,
    580, 576, 581, 581, 576, 582, 582, 576, 583, 583, 576, 584,
    584, 576, 585, 585, 576, 586, 586, 576, 587, 587, 576, 588,
    588, 576, 589, 589, 576, 590, 590, 576, 591, 591, 576, 592,
    592, 576, 593, 593, 576, 594, 594, 576, 595, 595, 576, 596,
    596, 576, 597, 597, 576, 598, 598, 576, 599, 599, 576, 600,
    600, 576, 601, 601, 576, 602, 602, 576, 603, 603, 576, 575,
    33, 31, 604, 33, 604, 605, 35, 33, 605, 35, 605, 606,
    31, 29, 607, 31, 607, 604, 37, 35, 606, 37, 606, 610,
    40, 37, 610, 40, 610, 609, 27, 40, 609, 27, 609, 608,
    29, 26, 608, 29, 608, 607, 21, 19, 611, 21, 611, 612,
    24, 23, 613, 24, 613, 614, 19, 17, 616, 19, 616, 611,
    41, 24, 615, 41, 615, 619, 43, 41, 619, 43, 619, 618,
    45, 43, 618, 45, 618, 617, 20, 22, 25, 25, 28, 30,
    30, 10, 11, 11, 12, 13, 13, 14, 15, 15, 16, 18,
    20, 25, 30, 15, 18, 20, 11, 13, 15, 20, 30, 11,
    11, 15, 20, 8, 9, 10, 10, 30, 32, 8, 10, 32,
    6, 7, 8, 4, 5, 6, 0, 3, 4, 60, 61, 0,
    58, 59, 60, 56, 57, 58, 54, 55, 56, 52, 53, 54,
    50, 51, 52, 48, 49, 50, 16, 47, 48, 46, 18, 16,
    46, 16, 48, 48, 50, 52, 52, 54, 56, 56, 58, 60,
    60, 0, 4, 4, 6, 8, 4, 8, 32, 46, 48, 52,
    44, 46, 52, 4, 32, 34, 4, 34, 36, 44, 52, 56,
    28, 25, 42, 42, 44, 56, 60, 4, 36, 60, 36, 38,
    39, 28, 42, 56, 60, 38, 38, 39, 42, 38, 42, 56,
  ]),
  normals: new Float32Array([
    -0.05980062, 0.99821034, 0.00000000,
    -0.22980847, 0.97323587, 0.00000000,
    -0.22471200, 0.97325199, -0.04780255,
    -0.05850061, 0.99821036, -0.01240013,
    -0.05460068, 0.99821253, -0.02430030,
    -0.04840054, 0.99821108, -0.03510039,
    -0.04000051, 0.99821268, -0.04440056,
    -0.02990029, 0.99820974, -0.05180051,
    -0.01850016, 0.99820844, -0.05690048,
    -0.00630005, 0.99820839, -0.05950050,
    0.00630005, 0.99820839, -0.05950050,
    0.01850016, 0.99820844, -0.05690048,
    0.02990029, 0.99820974, -0.05180051,
    0.04000051, 0.99821268, -0.04440056,
    0.04840054, 0.99821108, -0.03510039,
    0.05460068, 0.99821253, -0.02430030,
    0.05409834, 0.99846939, -0.01149965,
    -0.68087321, 0.73147124, 0.03689855,
    -0.68087321, 0.73147124, 0.03689855,
    -0.02769963, -0.55199257, 0.83338883,
    -0.02769963, -0.55199257, 0.83338883,
    0.53012460, 0.64913017, 0.54552537,
    0.53012460, 0.64913017, 0.54552537,
    0.53009570, 0.64909476, 0.54559559,
    0.45571181, 0.86662239, 0.20320526,
    0.45571181, 0.86662239, 0.20320526,
    -0.34770165, 0.92500438, 0.15320072,
    -0.34778952, 0.92497223, 0.15319539,
    -0.34778952, 0.92497223, 0.15319539,
    -0.58049960, 0.64219952, 0.50059963,
    -0.58049960, 0.64219952, 0.50059963,
    -0.02949912, -0.54858368, 0.83557510,
    -0.02950159, -0.54862951, 0.83554492,
    0.75219303, -0.64709395, 0.12439884,
    0.75219303, -0.64709395, 0.12439884,
    0.67638867, -0.63298940, -0.37659367,
    0.67638867, -0.63298940, -0.37659367,
    -0.05089983, -0.58129799, -0.81209719,
    -0.05089983, -0.58129799, -0.81209719,
    -0.67302570, -0.65042487, -0.35211347,
    -0.67308043, -0.65038107, -0.35208975,
    0.65541764, -0.64821745, -0.38761044,
    0.65541764, -0.64821745, -0.38761044,
    0.01210010, -0.58310487, -0.81230677,
    0.01210010, -0.58310487, -0.81230677,
    -0.62537671, -0.65437562, -0.42508414,
    -0.62537671, -0.65437562, -0.42508414,
    0.05980062, 0.99821034, 0.00000000,
    0.05850061, 0.99821036, 0.01240013,
    0.05460068, 0.99821253, 0.02430030,
    0.04840054, 0.99821108, 0.03510039,
    0.04000051, 0.99821268, 0.04440056,
    0.02990029, 0.99820974, 0.05180051,
    0.01850016, 0.99820844, 0.05690048,
    0.00630005, 0.99820839, 0.05950050,
    -0.00630005, 0.99820839, 0.05950050,
    -0.01850016, 0.99820844, 0.05690048,
    -0.02990029, 0.99820974, 0.05180051,
    -0.04000051, 0.99821268, 0.04440056,
    -0.04840054, 0.99821108, 0.03510039,
    -0.05460068, 0.99821253, 0.02430030,
    -0.05850061, 0.99821036, 0.01240013,
    -0.22471200, 0.97325199, 0.04780255,
    -0.43979830, 0.89809657, 0.00000000,
    -0.43019793, 0.89809568, -0.09139956,
    -0.20969890, 0.97329487, -0.09339951,
    -0.18590659, 0.97323452, -0.13510480,
    -0.15350420, 0.97332658, -0.17050465,
    -0.11470283, 0.97332401, -0.19870490,
    -0.07100194, 0.97322667, -0.21860598,
    -0.02400098, 0.97333966, -0.22810930,
    0.02400098, 0.97333966, -0.22810930,
    0.07100194, 0.97322667, -0.21860598,
    0.11469394, 0.97334861, -0.19858950,
    0.15350420, 0.97332658, -0.17050465,
    0.18590659, 0.97323452, -0.13510480,
    0.20950767, 0.97333567, -0.09340342,
    0.22471200, 0.97325199, -0.04780255,
    0.22980847, 0.97323587, 0.00000000,
    0.22471200, 0.97325199, 0.04780255,
    0.20969890, 0.97329487, 0.09339951,
    0.18590659, 0.97323452, 0.13510480,
    0.15369423, 0.97326347, 0.17069359,
    0.11480380, 0.97333217, 0.19860657,
    0.07099814, 0.97327447, 0.21839428,
    0.02399864, 0.97334492, 0.22808710,
    -0.02399864, 0.97334492, 0.22808710,
    -0.07099814, 0.97327447, 0.21839428,
    -0.11480380, 0.97333217, 0.19860657,
    -0.15369423, 0.97326347, 0.17069359,
    -0.18590659, 0.97323452, 0.13510480,
    -0.20950767, 0.97333567, 0.09340342,
    -0.43019793, 0.89809568, 0.09139956,
    -0.62761756, 0.77852180, 0.00000000,
    -0.61391052, 0.77851335, -0.13050224,
    -0.40179357, 0.89808560, -0.17889713,
    -0.35598830, 0.89797051, -0.25869151,
    -0.29420948, 0.89812898, -0.32681054,
    -0.22000385, 0.89801571, -0.38100668,
    -0.13590467, 0.89803082, -0.41841435,
    -0.04599958, 0.89809176, -0.43739597,
    0.04600148, 0.89822890, -0.43711407,
    0.13590467, 0.89803082, -0.41841435,
    0.22000385, 0.89801571, -0.38100668,
    0.29420948, 0.89812898, -0.32681054,
    0.35580008, 0.89810023, -0.25850006,
    0.40179357, 0.89808560, -0.17889713,
    0.43019793, 0.89809568, -0.09139956,
    0.43979830, 0.89809657, 0.00000000,
    0.43019793, 0.89809568, 0.09139956,
    0.40179357, 0.89808560, 0.17889713,
    0.35598830, 0.89797051, 0.25869151,
    0.29429121, 0.89807319, 0.32689024,
    0.21989731, 0.89808903, 0.38089534,
    0.13590383, 0.89812531, 0.41821177,
    0.04599958, 0.89809176, 0.43739597,
    -0.04599958, 0.89809176, 0.43739597,
    -0.13590383, 0.89812531, 0.41821177,
    -0.21989731, 0.89808903, 0.38089534,
    -0.29429121, 0.89807319, 0.32689024,
    -0.35580008, 0.89810023, 0.25850006,
    -0.40179357, 0.89808560, 0.17889713,
    -0.61391052, 0.77851335, 0.13050224,
    -0.78477526, 0.61978044, 0.00000000,
    -0.76738911, 0.62009120, -0.16309769,
    -0.57343668, 0.77844972, -0.25531629,
    -0.50798741, 0.77828063, -0.36909084,
    -0.42017314, 0.77825028, -0.46667016,
    -0.31398975, 0.77827458, -0.54378223,
    -0.19409639, 0.77818545, -0.59728888,
    -0.06560022, 0.77810270, -0.62470216,
    0.06560022, 0.77810270, -0.62470216,
    0.19409639, 0.77818545, -0.59728888,
    0.31398975, 0.77827458, -0.54378223,
    0.42017314, 0.77825028, -0.46667016,
    0.50798741, 0.77828063, -0.36909084,
    0.57343668, 0.77844972, -0.25531629,
    0.61391052, 0.77851335, -0.13050224,
    0.62761756, 0.77852180, 0.00000000,
    0.61391052, 0.77851335, 0.13050224,
    0.57343668, 0.77844972, 0.25531629,
    0.50798741, 0.77828063, 0.36909084,
    0.42009080, 0.77828296, 0.46668977,
    0.31389223, 0.77838077, 0.54368654,
    0.19399664, 0.77828648, 0.59718964,
    0.06550375, 0.77824445, 0.62453569,
    -0.06550375, 0.77824445, 0.62453569,
    -0.19399664, 0.77828648, 0.59718964,
    -0.31389223, 0.77838077, 0.54368654,
    -0.42009080, 0.77828296, 0.46668977,
    -0.50798741, 0.77828063, 0.36909084,
    -0.57343668, 0.77844972, 0.25531629,
    -0.76738911, 0.62009120, 0.16309769,
    -0.90236087, 0.43098128, 0.00000000,
    -0.88288393, 0.43049215, -0.18759658,
    -0.71683475, 0.61993005, -0.31911547,
    -0.63481510, 0.61991472, -0.46121094,
    -0.52517318, 0.61966842, -0.58327025,
    -0.39229617, 0.61999393, -0.67949337,
    -0.24250947, 0.61982417, -0.74632912,
    -0.08190100, 0.62000751, -0.78030950,
    0.08199901, 0.61989253, -0.78039055,
    0.24250947, 0.61982417, -0.74632912,
    0.39229384, 0.61989022, -0.67958933,
    0.52517318, 0.61966842, -0.58327025,
    0.63481510, 0.61991472, -0.46121094,
    0.71683475, 0.61993005, -0.31911547,
    0.76738911, 0.62009120, -0.16309769,
    0.78477526, 0.61978044, 0.00000000,
    0.76738911, 0.62009120, 0.16309769,
    0.71683475, 0.61993005, 0.31911547,
    0.63481510, 0.61991472, 0.46121094,
    0.52512562, 0.62003028, 0.58292841,
    0.39229617, 0.61999393, 0.67949337,
    0.24258547, 0.61976287, 0.74635532,
    0.08210096, 0.62010733, 0.78020916,
    -0.08210096, 0.62010733, 0.78020916,
    -0.24258547, 0.61976287, 0.74635532,
    -0.39229617, 0.61999393, 0.67949337,
    -0.52509887, 0.61979868, 0.58319874,
    -0.63481510, 0.61991472, 0.46121094,
    -0.71683475, 0.61993005, 0.31911547,
    -0.88268771, 0.43089400, 0.18759738,
    -0.97529663, 0.22089924, 0.00000000,
    -0.95400508, 0.22060116, -0.20300107,
    -0.82437009, 0.43088436, -0.36708668,
    -0.73021001, 0.43040592, -0.53060728,
    -0.60376194, 0.43107287, -0.67055776,
    -0.45111705, 0.43111632, -0.78142954,
    -0.27880033, 0.43100049, -0.85820100,
    -0.09430093, 0.43100424, -0.89740887,
    0.09429620, 0.43068263, -0.89756376,
    0.27880033, 0.43100049, -0.85820100,
    0.45129943, 0.43079946, -0.78149898,
    0.60378798, 0.43099142, -0.67058666,
    0.73007632, 0.43078602, -0.53048277,
    0.82437009, 0.43088436, -0.36708668,
    0.88288393, 0.43049215, -0.18759658,
    0.90230338, 0.43110161, 0.00000000,
    0.88262757, 0.43101348, 0.18760586,
    0.82433277, 0.43101713, 0.36701461,
    0.73021001, 0.43040592, 0.53060728,
    0.60376194, 0.43107287, 0.67055776,
    0.45111705, 0.43111632, 0.78142954,
    0.27880033, 0.43100049, 0.85820100,
    0.09430093, 0.43100424, 0.89740887,
    -0.09429620, 0.43068263, 0.89756376,
    -0.27869606, 0.43109396, 0.85818792,
    -0.45111705, 0.43111632, 0.78142954,
    -0.60380243, 0.43110176, 0.67050271,
    -0.73007632, 0.43078602, 0.53048277,
    -0.82433277, 0.43101713, 0.36701461,
    -0.95404379, 0.22061011, 0.20280932,
    -0.99844184, 0.05580234, 0.00000000,
    -0.99844184, 0.05580234, 0.00000000,
    -0.99844184, 0.05580234, 0.00000000,
    -0.97662549, 0.05570145, -0.20760542,
    -0.97662549, 0.05570145, -0.20760542,
    -0.89097426, 0.22109362, -0.39658855,
    -0.78902109, 0.22080592, -0.57331533,
    -0.65260832, 0.22080282, -0.72480928,
    -0.48759211, 0.22119642, -0.84458633,
    -0.30139453, 0.22079598, -0.92758314,
    -0.10189677, 0.22129300, -0.96986930,
    0.10189677, 0.22129300, -0.96986930,
    0.30139453, 0.22079598, -0.92758314,
    0.48759211, 0.22119642, -0.84458633,
    0.65250764, 0.22110260, -0.72480854,
    0.78902109, 0.22080592, -0.57331533,
    0.89097426, 0.22109362, -0.39658855,
    0.95400508, 0.22060116, -0.20300107,
    0.97529663, 0.22089924, 0.00000000,
    0.95404379, 0.22061011, 0.20280932,
    0.89097426, 0.22109362, 0.39658855,
    0.78902109, 0.22080592, 0.57331533,
    0.65260832, 0.22080282, 0.72480928,
    0.48760288, 0.22110131, 0.84460502,
    0.30138787, 0.22089110, 0.92756265,
    0.10189903, 0.22119788, 0.96989076,
    -0.10189677, 0.22129300, 0.96986930,
    -0.30140915, 0.22100672, 0.92752820,
    -0.48779650, 0.22109842, 0.84449397,
    -0.65238854, 0.22119611, 0.72488722,
    -0.78902109, 0.22080592, 0.57331533,
    -0.89097426, 0.22109362, 0.39658855,
    -0.97662004, 0.05580114, 0.20760425,
    -0.97662004, 0.05580114, 0.20760425,
    -1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -0.97814792, 0.00000000, -0.20791019,
    -0.91216314, 0.05599774, -0.40598357,
    -0.91216314, 0.05599774, -0.40598357,
    -0.80775714, 0.05579704, -0.58686889,
    -0.80775714, 0.05579704, -0.58686889,
    -0.66813405, 0.05590285, -0.74193784,
    -0.66813405, 0.05590285, -0.74193784,
    -0.49938821, 0.05579868, -0.86457962,
    -0.49938821, 0.05579868, -0.86457962,
    -0.30861232, 0.05600223, -0.94953788,
    -0.30861232, 0.05600223, -0.94953788,
    -0.10439501, 0.05609732, -0.99295255,
    -0.10439501, 0.05609732, -0.99295255,
    0.10439501, 0.05609732, -0.99295255,
    0.10439501, 0.05609732, -0.99295255,
    0.30861232, 0.05600223, -0.94953788,
    0.30861232, 0.05600223, -0.94953788,
    0.49938821, 0.05579868, -0.86457962,
    0.49938821, 0.05579868, -0.86457962,
    0.66813405, 0.05590285, -0.74193784,
    0.66813405, 0.05590285, -0.74193784,
    0.80780907, 0.05570062, -0.58680656,
    0.80780907, 0.05570062, -0.58680656,
    0.91216314, 0.05599774, -0.40598357,
    0.91216314, 0.05599774, -0.40598357,
    0.97662549, 0.05570145, -0.20760542,
    0.97662549, 0.05570145, -0.20760542,
    0.99844184, 0.05580234, 0.00000000,
    0.99844184, 0.05580234, 0.00000000,
    0.97662004, 0.05580114, 0.20760425,
    0.97662004, 0.05580114, 0.20760425,
    0.91205048, 0.05569697, 0.40627795,
    0.91205048, 0.05569697, 0.40627795,
    0.80775714, 0.05579704, 0.58686889,
    0.80775714, 0.05579704, 0.58686889,
    0.66813405, 0.05590285, 0.74193784,
    0.66813405, 0.05590285, 0.74193784,
    0.49931595, 0.05570178, 0.86462760,
    0.49931595, 0.05570178, 0.86462760,
    0.30849597, 0.05579927, 0.94958764,
    0.30849597, 0.05579927, 0.94958764,
    0.10439560, 0.05599764, 0.99295812,
    0.10439560, 0.05599764, 0.99295812,
    -0.10439501, 0.05609732, 0.99295255,
    -0.10439501, 0.05609732, 0.99295255,
    -0.30861403, 0.05590254, 0.94954320,
    -0.30861403, 0.05590254, 0.94954320,
    -0.49932150, 0.05550239, 0.86463722,
    -0.49932150, 0.05550239, 0.86463722,
    -0.66819688, 0.05569974, 0.74189653,
    -0.66819688, 0.05569974, 0.74189653,
    -0.80780907, 0.05570062, 0.58680656,
    -0.80780907, 0.05570062, 0.58680656,
    -0.91215802, 0.05609742, 0.40598131,
    -0.91215802, 0.05609742, 0.40598131,
    -0.97814792, 0.00000000, 0.20791019,
    -0.99844184, -0.05580234, 0.00000000,
    -0.99844184, -0.05580234, 0.00000000,
    -0.99844184, -0.05580234, 0.00000000,
    -0.97662549, -0.05570145, -0.20760542,
    -0.97662549, -0.05570145, -0.20760542,
    -0.91360525, 0.00000000, -0.40660231,
    -0.80895657, 0.00000000, -0.58786841,
    -0.66913599, 0.00000000, -0.74313998,
    -0.50012935, 0.00000000, -0.86595071,
    -0.30910870, 0.00000000, -0.95102672,
    -0.10460149, 0.00000000, -0.99451422,
    0.10460149, 0.00000000, -0.99451422,
    0.30910870, 0.00000000, -0.95102672,
    0.50012935, 0.00000000, -0.86595071,
    0.66913599, 0.00000000, -0.74313998,
    0.80895657, 0.00000000, -0.58786841,
    0.91360525, 0.00000000, -0.40660231,
    0.97814792, 0.00000000, -0.20791019,
    1.00000000, 0.00000000, 0.00000000,
    0.97814792, 0.00000000, 0.20791019,
    0.91360525, 0.00000000, 0.40660231,
    0.80895657, 0.00000000, 0.58786841,
    0.66913599, 0.00000000, 0.74313998,
    0.50001101, 0.00000000, 0.86601905,
    0.30910870, 0.00000000, 0.95102672,
    0.10460149, 0.00000000, 0.99451422,
    -0.10460149, 0.00000000, 0.99451422,
    -0.30910870, 0.00000000, 0.95102672,
    -0.50012935, 0.00000000, 0.86595071,
    -0.66913599, 0.00000000, 0.74313998,
    -0.80895657, 0.00000000, 0.58786841,
    -0.91360525, 0.00000000, 0.40660231,
    -0.97662004, -0.05580114, 0.20760425,
    -0.97662004, -0.05580114, 0.20760425,
    -0.97527509, -0.22099435, 0.00000000,
    -0.95393118, -0.22100722, -0.20290665,
    -0.91216314, -0.05599774, -0.40598357,
    -0.91216314, -0.05599774, -0.40598357,
    -0.80780907, -0.05570062, -0.58680656,
    -0.80780907, -0.05570062, -0.58680656,
    -0.66813405, -0.05590285, -0.74193784,
    -0.66813405, -0.05590285, -0.74193784,
    -0.49938821, -0.05579868, -0.86457962,
    -0.49938821, -0.05579868, -0.86457962,
    -0.30861232, -0.05600223, -0.94953788,
    -0.30861232, -0.05600223, -0.94953788,
    -0.10439501, -0.05609732, -0.99295255,
    -0.10439501, -0.05609732, -0.99295255,
    0.10439501, -0.05609732, -0.99295255,
    0.10439501, -0.05609732, -0.99295255,
    0.30861232, -0.05600223, -0.94953788,
    0.30861232, -0.05600223, -0.94953788,
    0.49938821, -0.05579868, -0.86457962,
    0.49938821, -0.05579868, -0.86457962,
    0.66813405, -0.05590285, -0.74193784,
    0.66813405, -0.05590285, -0.74193784,
    0.80780907, -0.05570062, -0.58680656,
    0.80780907, -0.05570062, -0.58680656,
    0.91216314, -0.05599774, -0.40598357,
    0.91216314, -0.05599774, -0.40598357,
    0.97662549, -0.05570145, -0.20760542,
    0.97662549, -0.05570145, -0.20760542,
    0.99844184, -0.05580234, 0.00000000,
    0.99844184, -0.05580234, 0.00000000,
    0.97662004, -0.05580114, 0.20760425,
    0.97662004, -0.05580114, 0.20760425,
    0.91208245, -0.05579893, 0.40619217,
    0.91208245, -0.05579893, 0.40619217,
    0.80780907, -0.05570062, 0.58680656,
    0.80780907, -0.05570062, 0.58680656,
    0.66813405, -0.05590285, 0.74193784,
    0.66813405, -0.05590285, 0.74193784,
    0.49931595, -0.05570178, 0.86462760,
    0.49931595, -0.05570178, 0.86462760,
    0.30849597, -0.05579927, 0.94958764,
    0.30849597, -0.05579927, 0.94958764,
    0.10439560, -0.05599764, 0.99295812,
    0.10439560, -0.05599764, 0.99295812,
    -0.10439501, -0.05609732, 0.99295255,
    -0.10439501, -0.05609732, 0.99295255,
    -0.30861403, -0.05590254, 0.94954320,
    -0.30861403, -0.05590254, 0.94954320,
    -0.49918934, -0.05599880, 0.86468152,
    -0.49918934, -0.05599880, 0.86468152,
    -0.66819688, -0.05569974, 0.74189653,
    -0.66819688, -0.05569974, 0.74189653,
    -0.80780907, -0.05570062, 0.58680656,
    -0.80780907, -0.05570062, 0.58680656,
    -0.91208245, -0.05579893, 0.40619217,
    -0.91208245, -0.05579893, 0.40619217,
    -0.95395953, -0.22099063, 0.20279139,
    -0.90239973, -0.43089990, 0.00000000,
    -0.88268771, -0.43089400, -0.18759738,
    -0.89091830, -0.22110454, -0.39670815,
    -0.78902109, -0.22080592, -0.57331533,
    -0.65259796, -0.22119932, -0.72469771,
    -0.48761365, -0.22100619, -0.84462370,
    -0.30138787, -0.22089110, -0.92756265,
    -0.10190352, -0.22100767, -0.96993365,
    0.10190352, -0.22100767, -0.96993365,
    0.30138787, -0.22089110, -0.92756265,
    0.48762444, -0.22091107, -0.84464235,
    0.65259796, -0.22119932, -0.72469771,
    0.78895134, -0.22118637, -0.57326466,
    0.89099798, -0.22079950, -0.39669909,
    0.95393118, -0.22100722, -0.20290665,
    0.97527509, -0.22099435, 0.00000000,
    0.95395953, -0.22099063, 0.20279139,
    0.89101765, -0.22070437, 0.39670785,
    0.78902109, -0.22080592, 0.57331533,
    0.65259796, -0.22119932, 0.72469771,
    0.48762444, -0.22091107, 0.84464235,
    0.30139453, -0.22079598, 0.92758314,
    0.10189815, -0.22079600, 0.96998242,
    -0.10190352, -0.22100767, 0.96993365,
    -0.30139453, -0.22079598, 0.92758314,
    -0.48761365, -0.22100619, 0.84462370,
    -0.65257545, -0.22069170, 0.72487272,
    -0.78895134, -0.22118637, 0.57326466,
    -0.89101765, -0.22070437, 0.39670785,
    -0.88270918, -0.43080445, 0.18770195,
    -0.78468818, -0.61989069, 0.00000000,
    -0.76738911, -0.62009120, -0.16309769,
    -0.82440561, -0.43080291, -0.36710250,
    -0.73010776, -0.43070458, -0.53050564,
    -0.60379085, -0.43129347, -0.67038986,
    -0.45117726, -0.43117823, -0.78136061,
    -0.27869596, -0.43129376, -0.85808756,
    -0.09429687, -0.43108568, -0.89737018,
    0.09429687, -0.43108568, -0.89737018,
    0.27869596, -0.43129376, -0.85808756,
    0.45121980, -0.43081888, -0.78153425,
    0.60377641, -0.43118315, -0.67047382,
    0.73010776, -0.43070458, -0.53050564,
    0.82440561, -0.43080291, -0.36710250,
    0.88268771, -0.43089400, -0.18759738,
    0.90226449, -0.43118302, 0.00000000,
    0.88270918, -0.43080445, 0.18770195,
    0.82447315, -0.43068597, 0.36708803,
    0.73010776, -0.43070458, 0.53050564,
    0.60379085, -0.43129347, 0.67038986,
    0.45117726, -0.43117823, 0.78136061,
    0.27869596, -0.43129376, 0.85808756,
    0.09429687, -0.43108568, 0.89737018,
    -0.09429687, -0.43108568, 0.89737018,
    -0.27878830, -0.43108192, 0.85816401,
    -0.45111705, -0.43111632, 0.78142954,
    -0.60378798, -0.43099142, 0.67058666,
    -0.73010776, -0.43070458, 0.53050564,
    -0.82433277, -0.43101713, 0.36701461,
    -0.76738911, -0.62009120, 0.16309769,
    -0.62761756, -0.77852180, 0.00000000,
    -0.61391052, -0.77851335, -0.13050224,
    -0.71683475, -0.61993005, -0.31911547,
    -0.63481510, -0.61991472, -0.46121094,
    -0.52509499, -0.61999411, -0.58299447,
    -0.39229617, -0.61999393, -0.67949337,
    -0.24260050, -0.61970132, -0.74640155,
    -0.08190100, -0.62000751, -0.78030950,
    0.08220010, -0.61960083, -0.78060102,
    0.24260050, -0.61970132, -0.74640155,
    0.39231817, -0.61982866, -0.67963143,
    0.52517318, -0.61966842, -0.58327025,
    0.63481510, -0.61991472, -0.46121094,
    0.71683475, -0.61993005, -0.31911547,
    0.76738911, -0.62009120, -0.16309769,
    0.78468818, -0.61989069, 0.00000000,
    0.76738911, -0.62009120, 0.16309769,
    0.71683475, -0.61993005, 0.31911547,
    0.63481510, -0.61991472, 0.46121094,
    0.52519610, -0.62009539, 0.58279564,
    0.39229617, -0.61999393, 0.67949337,
    0.24258547, -0.61976287, 0.74635532,
    0.08210096, -0.62010733, 0.78020916,
    -0.08210096, -0.62010733, 0.78020916,
    -0.24258547, -0.61976287, 0.74635532,
    -0.39229850, -0.62009760, 0.67939742,
    -0.52509887, -0.61979868, 0.58319874,
    -0.63481510, -0.61991472, 0.46121094,
    -0.71683475, -0.61993005, 0.31911547,
    -0.61391052, -0.77851335, 0.13050224,
    -0.43979830, -0.89809657, 0.00000000,
    -0.43019793, -0.89809568, -0.09139956,
    -0.57371263, -0.77821706, -0.25540560,
    -0.50798741, -0.77828063, -0.36909084,
    -0.42017314, -0.77825028, -0.46667016,
    -0.31398975, -0.77827458, -0.54378223,
    -0.19409639, -0.77818545, -0.59728888,
    -0.06560022, -0.77810270, -0.62470216,
    0.06560022, -0.77810270, -0.62470216,
    0.19409639, -0.77818545, -0.59728888,
    0.31398975, -0.77827458, -0.54378223,
    0.42017314, -0.77825028, -0.46667016,
    0.50798741, -0.77828063, -0.36909084,
    0.57371263, -0.77821706, -0.25540560,
    0.61391052, -0.77851335, -0.13050224,
    0.62761756, -0.77852180, 0.00000000,
    0.61391052, -0.77851335, 0.13050224,
    0.57371263, -0.77821706, 0.25540560,
    0.50798741, -0.77828063, 0.36909084,
    0.42009080, -0.77828296, 0.46668977,
    0.31389223, -0.77838077, 0.54368654,
    0.19399664, -0.77828648, 0.59718964,
    0.06550375, -0.77824445, 0.62453569,
    -0.06550375, -0.77824445, 0.62453569,
    -0.19399664, -0.77828648, 0.59718964,
    -0.31389223, -0.77838077, 0.54368654,
    -0.42009080, -0.77828296, 0.46668977,
    -0.50798741, -0.77828063, 0.36909084,
    -0.57371263, -0.77821706, 0.25540560,
    -0.43019793, -0.89809568, 0.09139956,
    -0.22980847, -0.97323587, 0.00000000,
    -0.22471200, -0.97325199, -0.04780255,
    -0.40179357, -0.89808560, -0.17889713,
    -0.35580008, -0.89810023, -0.25850006,
    -0.29449069, -0.89797161, -0.32698964,
    -0.22000385, -0.89801571, -0.38100668,
    -0.13590467, -0.89803082, -0.41841435,
    -0.04600148, -0.89822890, -0.43711407,
    0.04600148, -0.89822890, -0.43711407,
    0.13589899, -0.89799323, -0.41849686,
    0.22000385, -0.89801571, -0.38100668,
    0.29420948, -0.89812898, -0.32681054,
    0.35580008, -0.89810023, -0.25850006,
    0.40179357, -0.89808560, -0.17889713,
    0.43019793, -0.89809568, -0.09139956,
    0.43979830, -0.89809657, 0.00000000,
    0.43019793, -0.89809568, 0.09139956,
    0.40179357, -0.89808560, 0.17889713,
    0.35580008, -0.89810023, 0.25850006,
    0.29429121, -0.89807319, 0.32689024,
    0.21989731, -0.89808903, 0.38089534,
    0.13590383, -0.89812531, 0.41821177,
    0.04599958, -0.89809176, 0.43739597,
    -0.04599958, -0.89809176, 0.43739597,
    -0.13590383, -0.89812531, 0.41821177,
    -0.21989731, -0.89808903, 0.38089534,
    -0.29429121, -0.89807319, 0.32689024,
    -0.35580008, -0.89810023, 0.25850006,
    -0.40179357, -0.89808560, 0.17889713,
    -0.22471200, -0.97325199, 0.04780255,
    -0.05999990, -0.99819838, 0.00000000,
    -0.05850061, -0.99821036, -0.01240013,
    -0.20969890, -0.97329487, -0.09339951,
    -0.18590659, -0.97323452, -0.13510480,
    -0.15370656, -0.97324157, -0.17080729,
    -0.11490453, -0.97323832, -0.19900783,
    -0.07100194, -0.97322667, -0.21860598,
    -0.02400098, -0.97333966, -0.22810930,
    0.02399879, -0.97325079, -0.22848844,
    0.07100194, -0.97322667, -0.21860598,
    0.11490453, -0.97323832, -0.19900783,
    0.15350420, -0.97332658, -0.17050465,
    0.18590659, -0.97323452, -0.13510480,
    0.20950767, -0.97333567, -0.09340342,
    0.22471200, -0.97325199, -0.04780255,
    0.22980847, -0.97323587, 0.00000000,
    0.22471200, -0.97325199, 0.04780255,
    0.20969890, -0.97329487, 0.09339951,
    0.18590659, -0.97323452, 0.13510480,
    0.15369160, -0.97324685, 0.17079067,
    0.11480380, -0.97333217, 0.19860657,
    0.07099814, -0.97327447, 0.21839428,
    0.02399864, -0.97334492, 0.22808710,
    -0.02399864, -0.97334492, 0.22808710,
    -0.07099814, -0.97327447, 0.21839428,
    -0.11480380, -0.97333217, 0.19860657,
    -0.15369160, -0.97324685, 0.17079067,
    -0.18590659, -0.97323452, 0.13510480,
    -0.20950767, -0.97333567, 0.09340342,
    -0.05850061, -0.99821036, 0.01240013,
    0.00000000, -1.00000000, 0.00000000,
    -0.05509891, -0.99818029, -0.02449951,
    -0.04859973, -0.99819437, -0.03529980,
    -0.04039896, -0.99817434, -0.04489885,
    -0.02990014, -0.99820456, -0.05190024,
    -0.01850026, -0.99821411, -0.05680080,
    -0.00630005, -0.99820839, -0.05950050,
    0.00630005, -0.99820839, -0.05950050,
    0.01850026, -0.99821411, -0.05680080,
    0.02999989, -0.99819639, -0.05199981,
    0.04039896, -0.99817434, -0.04489885,
    0.04859973, -0.99819437, -0.03529980,
    0.05509891, -0.99818029, -0.02449951,
    0.05850061, -0.99821036, -0.01240013,
    0.05999990, -0.99819838, 0.00000000,
    0.05850061, -0.99821036, 0.01240013,
    0.05509891, -0.99818029, 0.02449951,
    0.04859973, -0.99819437, 0.03529980,
    0.04019983, -0.99819579, 0.04459981,
    0.03000005, -0.99820157, 0.05190008,
    0.01859991, -0.99819520, 0.05709973,
    0.00630005, -0.99820839, 0.05950050,
    -0.00630005, -0.99820839, 0.05950050,
    -0.01859991, -0.99819520, 0.05709973,
    -0.03000005, -0.99820157, 0.05190008,
    -0.04019983, -0.99819579, 0.04459981,
    -0.04859973, -0.99819437, 0.03529980,
    -0.05509891, -0.99818029, 0.02449951,
    -0.02949912, 0.54858368, 0.83557510,
    0.75219303, 0.64709395, 0.12439884,
    0.67638867, 0.63298940, -0.37659367,
    -0.58049960, -0.64219952, 0.50059963,
    -0.73429303, 0.59679436, 0.32349690,
    -0.67308043, 0.65038107, -0.35208975,
    -0.05089983, 0.58129799, -0.81209719,
    -0.02769963, 0.55199257, 0.83338883,
    0.53012460, -0.64913017, 0.54552537,
    0.53009570, -0.64909476, 0.54559559,
    0.73668587, 0.59108866, 0.32849372,
    0.73664014, 0.59113221, 0.32851791,
    -0.77552397, 0.62991941, 0.04200130,
    -0.62537671, 0.65437562, -0.42508414,
    0.01210010, 0.58310487, -0.81230677,
    0.65541764, 0.64821745, -0.38761044,
  ]),
  materialIndex: 0,
};

const SOUL_MESH_1: RuneMesh = {
  name: "Soul_Rune_primitive1",
  positions: new Float32Array([
    -0.48120001, 0.35769996, -0.45810002,
    -0.63400000, 0.35769999, -0.14900003,
    -0.57969999, 0.35770002, 0.26199996,
    -0.30450001, 0.35769999, -0.02670003,
    -0.07010000, 0.35769999, 0.11259997,
    -0.10750000, 0.35770002, 0.29259998,
    -0.29769999, 0.35770002, 0.49299997,
    0.54130000, 0.35769996, -0.39700004,
    0.31029999, 0.35769999, 0.01069997,
    0.02160000, 0.35769999, 0.16349997,
    0.67720002, 0.35769999, -0.11500003,
    0.52770001, 0.35770002, 0.30619997,
    0.25929999, 0.35770002, 0.54060000,
    0.07250000, 0.35770002, 0.36729997,
  ]),
  indices: new Uint16Array([
    2, 1, 0, 3, 4, 5, 2, 0, 3, 5, 6, 2,
    3, 5, 2, 8, 7, 10, 10, 11, 12, 12, 13, 9,
    9, 8, 10, 10, 12, 9,
  ]),
  normals: new Float32Array([
    -0.02949912, 0.54858368, 0.83557510,
    0.75219303, 0.64709395, 0.12439884,
    0.67638867, 0.63298940, -0.37659367,
    -0.58049960, -0.64219952, 0.50059963,
    -0.73429303, 0.59679436, 0.32349690,
    -0.67308043, 0.65038107, -0.35208975,
    -0.05089983, 0.58129799, -0.81209719,
    -0.02769963, 0.55199257, 0.83338883,
    0.53012460, -0.64913017, 0.54552537,
    0.73664014, 0.59113221, 0.32851791,
    -0.77552397, 0.62991941, 0.04200130,
    -0.62537671, 0.65437562, -0.42508414,
    0.01210010, 0.58310487, -0.81230677,
    0.65541764, 0.64821745, -0.38761044,
  ]),
  materialIndex: 1,
};

export const SOUL_MESHES: RuneMesh[] = [
  SOUL_MESH_0,
  SOUL_MESH_1,
];
